import { strings } from './constants'
import BrandNotificationBar from '@local/notification-bar'
import NotificationService from '../../services/NotificationService'

require('./index.css')

class BrandNotifications {
  constructor (root, notificationsList) {
    if (!BrandNotificationBar) {
      console.error('Dependence not found')
    }
    this.root_ = root
    this.placeholderType = this.root_.getAttribute(this.trimAttribute(strings.NOTIFICATION_PLACEHOLDER))
    this.notificationsList = notificationsList
    this.afterNotificationsLoaded(this.root_)
  }

  trimAttribute (url) {
    return url.replace('[', '').replace(']', '')
  }

  afterNotificationsLoaded (root) {
    let filteredNotifications = this.notificationsList.filter(notification => {
      if (notification.Position === this.placeholderType) {
        return notification
      }
    })
    this.loadNotifications(filteredNotifications)
  }

  createNotificationDom (notification) {
    let newNotificationDom = document.createElement('div')
    let cssClasses = notification.HtmlClass.split(' ')
    Array.prototype.forEach.call(cssClasses, (cssClass) => {
      newNotificationDom.classList.add(cssClass)
    })
    newNotificationDom.style.background = notification.Background
    let newText = document.createElement('p')
    newText.innerHTML = notification.HtmlContent
    newNotificationDom.appendChild(newText)
    return newNotificationDom
  }

  createCloseButton (notification) {
    let closeButton = document.createElement('button')
    let id = notification.Id
    let endDate = notification.EndDate
    closeButton.addEventListener('click', evt => {
      localStorage.setItem(id, endDate)
      evt.target.parentNode.classList.add(strings.HIDDEN_CLASS)
    })
    return closeButton
  }

  addNotification (notification) {
    let placeholder = document.querySelector('[' + this.trimAttribute(strings.NOTIFICATION_PLACEHOLDER) + '="' + this.placeholderType + '"]')
    if (placeholder !== null) {
      let notificationDom = this.createNotificationDom(notification)
      if (notification.IsCloseable) {
        notificationDom.classList.add(strings.CLOSABLE_CLASS)
        notificationDom.appendChild(this.createCloseButton(notification))
      }
      placeholder.appendChild(notificationDom)
    }
  }

  loadNotifications (notifications) {
    let storage = localStorage

    Array.prototype.forEach.call(notifications, (notification) => {
      if (this.isVisible(notification, storage)) {
        this.addNotification(notification)
      }
    })
  }

  isVisible (notification, storage) {
    return (this.canShow(notification, storage))
  }

  canShow (notification, storage) {
    let entry
    for (entry in storage) {
      if (entry === notification.Id) {
        return false
      }
    }
    return true
  }
}

const trimLastSlash = function (url) {
  let lastUrlIndex = url.length - 1
  return url.lastIndexOf('/') === lastUrlIndex ? url.substring(0, lastUrlIndex) : url
}

const init = function () {
  if (typeof (Storage) !== 'undefined') {
    let pageSlug = window.location.pathname === '/' || window.location.pathname === '' ? '/' : trimLastSlash(window.location.pathname)
    let baseUrl = document.querySelector(`meta[name='${strings.BASE_URL}']`).getAttribute('content') || ''
    let serviceName = document.querySelector(`meta[name='${strings.API_SERVICE_NAME}']`).getAttribute('content') || '/getnotifications'
    let notificationService = new NotificationService(baseUrl)
    if (pageSlug !== null) {
      notificationService.getNotifications(serviceName, pageSlug)
        .then(response => {
          var notificationsList = JSON.parse(response).notifications
          const allElements = document.querySelectorAll(strings.NOTIFICATION_PLACEHOLDER);
          [...allElements].filter(element => {
            let brandNotifications = new BrandNotifications(element, notificationsList)
            if (!brandNotifications) {
              console.error('Initialisation problem')
            }
          })
        })
        .catch(err => console.log(err)) // TBD better error handling then console log
    }
  } else {
    console.log('Local storage unsupported')
  }
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  init()
} else {
  document.addEventListener('DOMContentLoaded', function (event) {
    init()
  })
}

export default BrandNotifications



// WEBPACK FOOTER //
// ./src/components/notifications/index.js